export const nbOfSlotsPassedSelector = ({nbOfSlotsPassed}) => nbOfSlotsPassed